import React from 'react'

export const IconBook = (props: React.SVGAttributes<any>) => {
  return (
    <svg fill="currentColor" viewBox="150.6 242.4 294.7 357.2" {...props}>
      <path d="M444.7 254.3c0-6.5-5.4-11.9-11.9-11.9H185.1c-19 0-34.5 15.5-34.5 34.5v266.7h.6c0 1.8-.6 4.2-.6 6.5 0 27.4 22 49.4 49.4 49.4h233.3c6.5 0 11.9-5.4 11.9-11.9v-75c0-1.2 0-2.4-.6-3.6h.6V254.3h-.5zM353 266.2h33.3v77.4l-7.7-8.9c-2.4-2.4-5.4-4.2-8.9-4.2-3.6 0-6.5 1.2-8.9 4.2l-7.7 8.9v-77.4zm-167.9 0h144.1v108.9c0 4.8 3 9.5 7.7 11.3 4.8 1.8 10.1.6 13.1-3l19.6-22 19.6 22c2.4 2.4 5.4 4.2 8.9 4.2 1.2 0 3 0 4.2-.6 4.8-1.8 7.7-6 7.7-11.3V266.2h11.3v234.5H200c-9.5 0-17.9 3-25.6 7.1v-231c0-5.9 4.8-10.6 10.7-10.6zM200 575.7c-14.3 0-25.6-11.3-25.6-25.6s11.3-25.6 25.6-25.6h221.4v13.7H219.1c-6.5 0-11.9 5.4-11.9 11.9s5.4 11.9 11.9 11.9h202.4v13.7H200z" />
    </svg>
  )
}
